import Calc from './modules/calc';
import Cart from './modules/cart';
import Counter from './modules/counter';
import Cable from './modules/cable';



const calc = new Calc;
const cart = new Cart;
const counter = new Counter;
const cable = new Cable;

